import { render, staticRenderFns } from "./AnonymousHeader.vue?vue&type=template&id=c7513332&"
import script from "./AnonymousHeader.vue?vue&type=script&lang=ts&"
export * from "./AnonymousHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports